import { createSlice } from "@reduxjs/toolkit";
import {
  getActualVideo,
  getAllNews,
  getGallery,
  getSingleNews,
} from "../../api/news";

const initialState = {
  news: {},
  newsLoading: false,

  mainNews: {},

  singleNews: {},
  singleNewsLoading: false,

  gallery: {},
  galLoading: false,

  actualVideo: {},
  actualVideoLoading: false,
};

const newsSlice = createSlice({
  name: "news",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllNews.pending, (state) => {
        state.newsLoading = true;
      })
      .addCase(getAllNews.fulfilled, (state, { meta, payload }) => {
        if (meta.arg.main) {
          state.mainNews = payload;
        } else {
          state.news = payload;
        }
        state.newsLoading = false;
      })
      .addCase(getAllNews.rejected, (state, { error }) => {
        state.newsLoading = false;
        console.log(error);
      })

      // single news
      .addCase(getSingleNews.pending, (state) => {
        state.singleNewsLoading = true;
      })
      .addCase(getSingleNews.fulfilled, (state, { payload }) => {
        state.singleNews = payload;
        state.singleNewsLoading = false;
      })
      .addCase(getSingleNews.rejected, (state, { error }) => {
        state.singleNewsLoading = false;
        console.log(error);
      })

      //gallery
      .addCase(getGallery.pending, (state) => {
        state.galLoading = true;
      })
      .addCase(getGallery.fulfilled, (state, { payload }) => {
        state.gallery = payload;
        state.galLoading = false;
      })

      // actual-video
      .addCase(getActualVideo.pending, (state) => {
        state.actualVideoLoading = true;
      })
      .addCase(getActualVideo.fulfilled, (state, { payload }) => {
        state.actualVideo = payload;
        state.actualVideoLoading = false;
      });
  },
});

// export const {} = newsSlice.actions;
export default newsSlice.reducer;
